import { estateTaskAssignableTeams, teams } from '@/modules/team/store/team.state';
import { Team } from '@/modules/team/models/Team';
import { AuthUser } from '@/modules/auth/models/AuthUser';
import { TeamCollection } from '@/modules/team/models/TeamCollection';

/**
 * @deprecated
 */
export function getAllEstateTaskAssignableTeams(): Team[] {
  return estateTaskAssignableTeams.value.get() as Team[];
}

/**
 * @deprecated
 */
export function getEstateTaskAssignableTeams(authUser: AuthUser): TeamCollection {
  if (
    !authUser?.permission?.canAssignEstateTaskToTeam ||
    !estateTaskAssignableTeams.value.hasItems
  ) {
    return new TeamCollection(null);
  }

  return new TeamCollection(estateTaskAssignableTeams.value.items);
}

/**
 * @deprecated
 */
export function getAssignableJepTeam(): Team | undefined {
  return estateTaskAssignableTeams.value.items?.find(
    (team: Team) => team.isJuniorEstateProfessionalTeam
  );
}

export function getTeams(): TeamCollection | undefined {
  return teams.value;
}

export function hasTeams(): boolean {
  if (!teams.value) {
    return false;
  }

  return teams.value.count > 0;
}
